import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Silence the benign "ResizeObserver loop completed with undelivered notifications"
// warning (triggered by Radix UI Select) so the CRA dev error overlay doesn't block the UI.
window.addEventListener(
  "error",
  (e) => {
    if (e.message && /ResizeObserver loop/.test(e.message)) {
      e.stopImmediatePropagation();
    }
  },
  true
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
